import html from "./ProjectList.html"
import "./ProjectList.css"

var module = angular.module("ResearchKitApplicationModule");
module.component('projectListDashboardComponent', {
	template: html,
	bindings: {
		"model": "<"
	},
	controller: 'projectListController',
	controllerAs: 'vm'
});

module.controller("projectListController", ["$scope", "ceUrl",
	function ($scope, ceUrl) {
		var vm = this;

		vm.brandingImageUrl = function (project) {
			// Aug-23-2021: String interpolation here can break the minifier/bundler.
			return "url('" + ceUrl.make("/api/researchkit/organizationbrandingimage/" + project.OrganizationID) + "')";
		}

		vm.selectProject = function (project) {
			$scope.$emit("NavigateToView", { type: "ProjectDetail", code: project.StudyCode });
		}
	}
]);